import { PhoneCall, HeartPulse } from "lucide-react";
import { Reveal, ChapterTag } from "./Reveal";

const KRISEN = [
    { name: "Die Dargebotene Hand", number: "143", desc: "Sorgen-Telefon, rund um die Uhr", testid: "krisen-card-143", href: "tel:143" },
    { name: "Pro Juventute", number: "147", desc: "Beratung für Kinder und Jugendliche – Anruf, SMS oder Chat", testid: "krisen-card-147", href: "tel:147" },
    { name: "Sanitätsnotruf", number: "144", desc: "Bei medizinischen Notfällen", testid: "krisen-card-144", href: "tel:144" },
    { name: "Polizeinotruf", number: "117", desc: "Bei akuter Gefahr für dich oder andere", testid: "krisen-card-117", href: "tel:117" },
];

export const Abgrenzung = () => (
    <section id="abgrenzung" data-testid="abgrenzung-section" className="py-24 sm:py-32 lg:py-40 bg-[#F4F1EA]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <Reveal>
                <ChapterTag number="06" label="Wichtige Abgrenzung" />
                <h2 className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825] max-w-3xl">
                    Was meine Beratung ist und was nicht
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <div
                    data-testid="abgrenzung-psychotherapie-notice"
                    className="mt-12 border-l-2 border-[#7C6E5C] bg-[#FAF8F5] p-8 sm:p-12 max-w-4xl"
                >
                    <div className="space-y-5 font-sans text-base font-light leading-relaxed text-[#59534C]">
                        <p>
                            Mein Angebot ist eine <strong className="font-medium text-[#2B2825]">psychosoziale Beratung</strong> und{" "}
                            <strong className="font-medium text-[#2B2825]">keine Psychotherapie oder medizinische Behandlung</strong>.
                            Ich stelle keine psychischen Diagnosen und behandle keine psychischen Erkrankungen.
                        </p>
                        <p>
                            Wenn sich im Gespräch zeigt, dass eine psychotherapeutische, psychiatrische oder
                            medizinische Unterstützung sinnvoll oder notwendig wäre, besprechen wir das offen.
                            Wenn gewünscht, kann ich dabei unterstützen, eine passende Fachstelle zu finden.
                        </p>
                        <p>
                            Bei akuten Krisen oder unmittelbarer Selbst- oder Fremdgefährdung ist dieses
                            Beratungsangebot nicht die geeignete Anlaufstelle. In solchen Situationen sollen die
                            entsprechenden Notfall- und Krisendienste kontaktiert werden.
                        </p>
                    </div>
                </div>
            </Reveal>

            <Reveal delay={0.18}>
                <div className="mt-16">
                    <div className="flex items-center gap-3 mb-8">
                        <HeartPulse size={20} strokeWidth={1.5} className="text-[#A0522D]" />
                        <h3 className="font-serif font-medium text-2xl text-[#2B2825]">
                            In akuten Krisen: Diese Stellen sind rund um die Uhr für dich da
                        </h3>
                    </div>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#DDD6C8] border border-[#DDD6C8]">
                        {KRISEN.map((k) => (
                            <a
                                key={k.number}
                                data-testid={k.testid}
                                href={k.href}
                                className="group bg-[#F4F1EA] p-7 sm:p-8 hover:bg-[#FAF8F5] transition-colors duration-500"
                            >
                                <div className="flex items-center justify-between mb-4">
                                    <span className="font-serif font-light text-5xl text-[#2B2825] group-hover:text-[#A0522D] transition-colors duration-500">
                                        {k.number}
                                    </span>
                                    <PhoneCall size={17} strokeWidth={1.5} className="text-[#8C8275] group-hover:text-[#A0522D] transition-colors duration-500" />
                                </div>
                                <p className="font-sans text-sm font-medium text-[#2B2825]">{k.name}</p>
                                <p className="font-sans text-xs font-light leading-relaxed text-[#59534C] mt-1.5">{k.desc}</p>
                            </a>
                        ))}
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
